// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order_order_container__1Aiof {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-left: none;
  border-top: none;
  padding: 19px;
}
@media screen and (max-width: 781px) {
  .order_order_container__1Aiof {
    border: none;
    padding: 14px;
  }
}
.order_order_container__1Aiof .order_plan__LPs3P {
  height: 106px;
  border-radius: 12px;
  border: 1px solid var(--re-border-color);
  display: flex;
  flex-wrap: wrap;
  padding: 15px 18px 20px;
}
@media (max-width: 781px) {
  .order_order_container__1Aiof .order_plan__LPs3P {
    height: 189px;
  }
}
.order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN {
  width: 50%;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN .order_bland_icon__5TA-e {
  display: flex;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN .order_brand_title__MYNlx {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 6px;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN .order_brand_description__tJDWV {
  width: 288px;
  max-width: 288px;
  min-width: 288px;
  color: var(--font-dark-color);
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  line-height: 18px;
  margin-top: 10px;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT {
  width: 50%;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT .order_brand_label__vYORU {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  float: right;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT div {
  width: 272px;
  height: 42px;
  margin-top: 33px;
  margin-right: -50px;
  float: right;
}
.order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT div input {
  width: 100%;
}
@media screen and (max-width: 781px) {
  .order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT div {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media (max-width: 781px) {
  .order_order_container__1Aiof .order_plan__LPs3P .order_bland__2EPaN,
  .order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT {
    width: 100%;
  }
  .order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT {
    margin-top: 13px;
  }
  .order_order_container__1Aiof .order_plan__LPs3P .order_search__ygDlT .order_brand_label__vYORU {
    float: left;
    margin-left: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/order/order.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AACJ;AACI;EARJ;IASQ,YAAA;IACA,aAAA;EAEN;AACF;AAAI;EACI,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAER;AAAQ;EARJ;IASQ,aAAA;EAGV;AACF;AADQ;EACI,UAAA;AAGZ;AADY;EACI,aAAA;AAGhB;AAAY;EACI,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAEhB;AACY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAChB;AAEY;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAhB;AAIQ;EACI,UAAA;AAFZ;AAIY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAFhB;AAKY;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAHhB;AAKgB;EACI,WAAA;AAHpB;AAMgB;EAXJ;IAYQ,WAAA;IACA,eAAA;IACA,gBAAA;EAHlB;AACF;AAQQ;EACI;;IAEI,WAAA;EANd;EASU;IACI,gBAAA;EAPd;EASc;IACI,WAAA;IACA,gBAAA;EAPlB;AACF","sourcesContent":[".order_container {\n    width: 100%;\n    height: 100%;\n    border: 1px solid var(--sb-border-color);\n    border-left: none;\n    border-top: none;\n    padding: 19px;\n\n    @media screen and (max-width: 781px) {\n        border: none;\n        padding: 14px;\n    }\n\n    .plan {\n        height: 106px;\n        border-radius: 12px;\n        border: 1px solid var(--re-border-color);\n        display: flex;\n        flex-wrap: wrap;\n        padding: 15px 18px 20px;\n\n        @media (max-width: 781px) {\n            height: 189px;\n        }\n\n        .bland {\n            width: 50%;\n\n            .bland_icon {\n                display: flex;\n            }\n\n            span {\n                color: var(--font-dark-color);\n                font-family: Red Hat Display;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n                margin-top: 7px;\n            }\n\n            .brand_title {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                margin-left: 6px;\n            }\n\n            .brand_description {\n                width: 288px;\n                max-width: 288px;\n                min-width: 288px;\n                color: var(--font-dark-color);\n                font-size: 12px;\n                text-align: left;\n                font-weight: 500;\n                line-height: 18px;\n                margin-top: 10px;\n            }\n        }\n\n        .search {\n            width: 50%;\n\n            .brand_label {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n                float: right;\n            }\n\n            div {\n                width: 272px;\n                height: 42px;\n                margin-top: 33px;\n                margin-right: -50px;\n                float: right;\n\n                input {\n                    width: 100%;\n                }\n\n                @media screen and (max-width: 781px) {\n                    width: 100%;\n                    margin-right: 0;\n                    margin-top: 10px;\n                    \n                }\n            }\n        }\n\n        @media (max-width: 781px) {\n            .bland,\n            .search {\n                width: 100%;\n            }\n\n            .search {\n                margin-top: 13px;\n\n                .brand_label {\n                    float: left;\n                    margin-left: 5px;\n                }\n            }\n        }\n    }\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order_container": `order_order_container__1Aiof`,
	"plan": `order_plan__LPs3P`,
	"bland": `order_bland__2EPaN`,
	"bland_icon": `order_bland_icon__5TA-e`,
	"brand_title": `order_brand_title__MYNlx`,
	"brand_description": `order_brand_description__tJDWV`,
	"search": `order_search__ygDlT`,
	"brand_label": `order_brand_label__vYORU`
};
export default ___CSS_LOADER_EXPORT___;
